import api from '../../api';
import models from '../../../models';
import output from '../../../utils/output-writer';
import { WrappedRegisterToolFuncType } from '../tool-definition';
import { createCallToolResult, createTextContent } from '../output-parser';

const getPlaybookInputSchema = models.tool.getPlaybookInput;

export function setup(register: WrappedRegisterToolFuncType) {
  register(
    'get-playbook',
    {
      title: 'Get Playbook',
      description:
        'Fetch a playbook by book name. Currently only fetches playbooks visible to all users.',
      inputSchema: getPlaybookInputSchema,
    },
    async ({ name }) => {
      output.info(`Fetching playbook ${name}`);

      const result = await api.getPlaybook({ name });

      return createCallToolResult({
        contentBlocks: [createTextContent(JSON.stringify(result, null, 2))],
      });
    }
  );
}

export default { setup };
